/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TokenVerificationDto model module.
 * @module model/TokenVerificationDto
 * @version v0
 */
class TokenVerificationDto {
    /**
     * Constructs a new <code>TokenVerificationDto</code>.
     * @alias module:model/TokenVerificationDto
     */
    constructor() { 
        
        TokenVerificationDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TokenVerificationDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TokenVerificationDto} obj Optional instance to populate.
     * @return {module:model/TokenVerificationDto} The populated <code>TokenVerificationDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TokenVerificationDto();

            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
            if (data.hasOwnProperty('expiresAt')) {
                obj['expiresAt'] = ApiClient.convertToType(data['expiresAt'], 'Date');
            }
            if (data.hasOwnProperty('refreshTokenExpiresAt')) {
                obj['refreshTokenExpiresAt'] = ApiClient.convertToType(data['refreshTokenExpiresAt'], 'Date');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TokenVerificationDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TokenVerificationDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['username'] && !(typeof data['username'] === 'string' || data['username'] instanceof String)) {
            throw new Error("Expected the field `username` to be a primitive type in the JSON string but got " + data['username']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}



/**
 * @member {Boolean} valid
 */
TokenVerificationDto.prototype['valid'] = undefined;

/**
 * @member {Number} userId
 */
TokenVerificationDto.prototype['userId'] = undefined;

/**
 * @member {String} username
 */
TokenVerificationDto.prototype['username'] = undefined;

/**
 * @member {Date} expiresAt
 */
TokenVerificationDto.prototype['expiresAt'] = undefined;

/**
 * @member {Date} refreshTokenExpiresAt
 */
TokenVerificationDto.prototype['refreshTokenExpiresAt'] = undefined;

/**
 * @member {String} message
 */
TokenVerificationDto.prototype['message'] = undefined;






export default TokenVerificationDto;

